import { TRAINER_PROFILE } from "../../actions/trainer/trainer_profile_action";

const initState = {
  is_done: false,
  loading: false,
  errors: [],
  list: [],
  trainerDetails: {},
  list: [],
};

const trainerProfileReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case TRAINER_PROFILE.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
        is_done: false,
      };

    case TRAINER_PROFILE.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        list: [],
        trainerDetails: {},
      };

    case TRAINER_PROFILE.UPDATE_TRAINER_PROFILE:
      return {
        ...state,
        loading: false,
        is_done: true,
        errors: [],
      };

    case TRAINER_PROFILE.GET_TRAINER_PROFILE:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        list: [],
        trainerDetails: payload,
      };
    case TRAINER_PROFILE.GET_TRAINER_ASSIGNED_TRAINING:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        list: payload,
      };
    default:
      return state;
  }
};

export default trainerProfileReducer;
